import { Row, Col } from "reactstrap";
import TheBizLogo from "./../../Images/dinbiz-logo.png";
import QuestionMarkIcon from "./../../Images/question-mark.png";

const HeaderTrial = ({ setHelpModalActive, setHelpModalContent }) => {
  const handleHelpModal = () => {
    setHelpModalActive(true);
    setHelpModalContent("1.0");
  };

  return (
    <Row className="master-header mb-2">
      <Col>
        <Row style={{ maxWidth: "1440px", margin: "0 auto" }}>
          <Col
            xs={4}
            className="d-flex align-items-center justify-content-center"
            style={{ padding: "0px" }}
          >
            <img
              src={TheBizLogo}
              alt="logo"
              className="img-fluid max-width:100% height:auto mx-auto d-block p-1"
            />
          </Col>

          <Col
            xs={1}
            className="offset-35 master-header-button p-1"
            style={{ padding: "0px" }}
            onClick={handleHelpModal}
          >
            <Row className="g-0">
              <Col
                xs={40}
                className="d-flex align-items-center justify-content-center"
              >
                <img
                  src={QuestionMarkIcon}
                  alt="question mark icon"
                  className="img-fluid max-width:100% height:auto mx-auto d-block w-75 pt-1"
                />
              </Col>
            </Row>
            <Row className="g-0">
              <Col
                xs={40}
                className="d-flex align-items-center justify-content-center"
              >
                <span
                  className="text-white fw-bold master-header-button-text pb-1"
                  style={{ lineHeight: "1" }}
                >
                  Hjälp
                </span>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
export default HeaderTrial;
